import cloneDeep from 'lodash/cloneDeep';
import { getAll } from '@/api/commande/index';
import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import * as devisConf from '@/configuration/devisConf';
import genererCritereDevisCommande from '@/services/devisCommandes/genererCritereDevisCommande';
import postGetCommandesList from '@/services/devisCommandes/postGetCommandesList';
import * as types from './commande-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    commandes: [],
    lastDataFromLoad: {},
    totalCommandes: 0,
    commande: null,
    criteresRecherche: cloneDeep(genererCritereDevisCommande()),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_COMMANDES](state, commandes) {
    state.commandes = commandes;
  },
  [types.SET_TOTAL_COMMANDES](state, totalCommandes) {
    state.totalCommandes = totalCommandes;
  },
  [types.SET_COMMANDE](state, commande) {
    state.commande = commande;
  },
  [types.SET_COMMANDE_LASTDATAFROMLOAD](state, lastDataFromLoad) {
    state.lastDataFromLoad = lastDataFromLoad;
  },
  [types.REMOVE_COMMANDE](state) {
    state.commande = null;
  },
  [types.SET_CRITERE_RECHERCHE](state, critere) {
    state.criteresRecherche = critere;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadCommandes({ commit }, data) {
    data.query.type = devisConf.TYPE_COMMANDE;
    commit(types.SET_COMMANDE_LASTDATAFROMLOAD, data);
    const response = await getAll(data);
    response.data.result.items.forEach(postGetCommandesList);

    commit(types.SET_TOTAL_COMMANDES, response.data.result.totalCount);
    commit(types.SET_COMMANDES, response.data.result.items);
    return {};
  },
};

const getters = {
  commandes: state => {
    return state.commandes;
  },
  totalCommandes: state => {
    return state.totalCommandes;
  },
  commande: state => {
    return state.commande;
  },
  lastDataFromLoad: state => {
    return transform(state.lastDataFromLoad);
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
